import styles from './styles.module.css';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import DataTable from 'components/utils/DataTable';
import Info from 'components/utils/Alert/Info';
import DateTimeHelpers from 'helpers/DateTimeHelpers';
import { useTranslation } from 'react-i18next';

export default function ShiftPaymentCashBookPopup(props) {
  const { toggleViewCashBook, rowData } = props;
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const listHeader = [
    {
      id: 'date',
      label: tCommon('Date'),
      type: 'callback',
      viewRender: (item) => DateTimeHelpers.getDate(item.time),
    },
    {
      id: 'time',
      label: tCommon('Time'),
      type: 'callback',
      viewRender: (item) => DateTimeHelpers.convertTo12HourTime(item.time),
    },
    {
      id: 'description',
      label: tCommon('Description'),
      type: 'text',
    },
    {
      id: 'debit',
      label: tCommon('In'),
      type: 'floatAmount',
    },
    {
      id: 'credit',
      label: tCommon('Out'),
      type: 'floatAmount',
    },
    {
      id: 'balance',
      label: tCommon('Balance'),
      type: 'floatAmount',
    },
  ];

  return (
    <div className={styles.popUp}>
      <div className={styles.contentWrapper}>
        <div className={styles.headSec}>
          <h2 className={styles.editTitle}>{`${rowData?.summary?.payment_mode?.name} ${tCommon('Book')}`}</h2>
          <CloseIcon
            onClick={() => {
              toggleViewCashBook(null);
            }}
          />
        </div>
        <div className={styles.inputSec}>
          {rowData.tnx ? (
            <DataTable columns={listHeader} rows={rowData.tnx} />
          ) : (
            <Info
              title={tPopup('Cash Book Details not found')}
              content={tPopup('This cash book have no transaction to list up')}
            />
          )}
        </div>
      </div>
    </div>
  );
}
